/**
 * @generated SignedSource<<31996b202e86c05407fab81a2bb9e537>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductBaseTile_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetails_user">;
  readonly " $fragmentType": "ProductBaseTile_user";
};
export type ProductBaseTile_user$key = {
  readonly " $data"?: ProductBaseTile_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductBaseTile_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductDetails_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d8cb0fa1a640dcce26c68e65ac1360a6";

export default node;
